import ENV from "../env";
import getAuthHeaders from "./authHeaders";

const saveCustomer = async (updatedCustomer) => {
  console.log(updatedCustomer);
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${ENV.firebaseApiUrl}/customer/save`, {
    method: "POST",
    headers,
    body: JSON.stringify({ updatedCustomer }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Create customer failed: " + resData.message);
  }

  return resData.success;
};

export default saveCustomer;
